import useAxios from 'middleware/useAxios';
import React from 'react'
import "./ShowPrefaktorDocuments.scss"



import { Button, Space, Table, Form, Input, Select, } from "antd";
import Axios from "middleware/axiosInstance";
import { Link, useParams } from "react-router-dom";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Loading from "layouts/Loading/Loading";
import { convertToShamsi, convertToMiladi } from "utils/dateCoverter";
import { useState, useEffect } from "react";
import { Row, Col } from "antd";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Icon from "react-multi-date-picker/components/icon";
import axios from "axios";




const ShowPrefaktorDocuments = () => {

  const [sortedInfo, setSortedInfo] = useState({});

  const [filteredInfo, setFilteredInfo] = useState({});


  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


  const [allPrefactor] =
    useAxios({
      method: "get",
      url: "/invoice",
    });

  const columns = [
    {
      title: "شماره پیش فاکتور",
      dataIndex: "id",
      key: "id",
      // filters: data.map((item) => {
      //   return (
      //     {
      //       "text": item.name,
      //       "value": item.goods_name,
      //     }
      //   )
      // }),

      // filteredValue: filteredInfo.name || null,
      // sorter: (a, b) => a.name.length - b.name.length,
      sorter: (a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0),

      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      render: (date) => (
        <span>
          {/* {moment(`${date}`, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD")} */}
          {convertToShamsi(date)}
          {/* {date} */}
        </span>
      ),
      // filters: allPrefactor?.map((item) => {
      //   return (
      //     {
      //       "text":convertToShamsi(item.date),
      //       "value": item.date,
      //     }
      //   )
      // }),
      filters: allPrefactor?.filter((v, i, a) => a.findIndex((v2) => v2.date === v.date) === i)
        .map((item) => {
          return {
            // text: item.date,
            text: convertToShamsi(item.date),
            value: item.date,
          };
        }),
      // filterMultiple: false,
      filteredValue: filteredInfo.date || null,
      onFilter: (value, record) => record.date.includes(value),
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),

      sortOrder:
        sortedInfo.columnKey === "goods_name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "شناسه کالا",
      dataIndex: "shenaseh",
      key: "shenaseh",
      // render: (date) => (
      //   <span>{date}
      //   </span>
      // ),
      sorter: (a, b) => a.shenaseh - b.shenaseh,
      sortOrder: sortedInfo.columnKey === "shenaseh" ? sortedInfo.order : null,
      ellipsis: true,
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, item) => (
        // <Space size="middle">

        //   <Link to={`/warehouse/commodity-and-services-details/${item.id}`}>جزییات</Link>
        //   {/* <Link to={`/war`}>جزییات</Link> */}
        //   <span
        //     onClick={
        //       () => deleteCommodity(item)
        //     }
        //   >
        //     حذف
        //   </span>
        // </Space >
        <Space size="small">
          {/* <Link
            to={`/warehouse/edit-commodity-and-services/${item.id}`}
            className="btn btn-primary btn-sm"
          >
            ویرایش
          </Link> */}
          <Link
            to={`/prefaktor/show-prefaktor-document/${item.id}`}
            className="btn btn-success btn-sm"
          >
            جزییات
          </Link>
          {/* <button
            // onClick={() => deleteCommodity(item)}
            className="btn btn-danger btn-sm"
          >
            حذف
          </button> */}
        </Space>
      ),
    },
  ];



  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">مشاهده تمام پیش فاکتورها</h5>
        {allPrefactor ? (
          allPrefactor[0] ? (
            <>
              <Space
                style={{
                  marginBottom: 16,
                }}
              >
                <Button onClick={clearFilters}>حذف فیلترها</Button>
                <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
              </Space>
              <Table
                pagination={false}
                dataSource={allPrefactor}
                rowKey={allPrefactor.id}
                onChange={handleChange}
                columns={columns}

              />
            </>
          ) : (
            <h2>محتوایی نیست</h2>
          )
        ) : (
          <Loading />
        )}
      </div>
    </div>
  )
}

export default ShowPrefaktorDocuments